export enum ReportsNeoFacetKeys {
    audienceReach = 'AUDIENCE_REACH',
    sentimentTrend = 'SENTIMENT_TREND',
    overtimeFacet = 'OVER_TIME',
    sentimentOverTime = 'SENTIMENT_OVER_TIME',
    engagementsOverTimeFacet = 'ENGAGEMENTS_OVER_TIME',
    impressionsOverTimeFacet = 'IMPRESSIONS_OVER_TIME',
    aveOverTimeFacet = 'AVE_OVER_TIME',
    sentimentByMediaType = 'SENTIMENT_BY_MEDIA_TYPE',

    mediaTypeImpressions = 'MEDIA_TYPE_X_IMPRESSIONS',
    mediaTypeEngagements = 'MEDIA_TYPE_X_ENGAGEMENTS',

    socialCoverageByNetwork = 'SOCIAL_COVERAGE_BY_NETWORK',
    engagementTotal = 'ENGAGEMENT_TOTAL',
    engagementTotalLikes = 'TOTAL_LIKES',
    engagementTotalReply = 'TOTAL_REPLY',
    engagementTotalShare = 'TOTAL_SHARE',
    engagementTotalView = 'TOTAL_VIEW',
    engagementTotalQuotes = 'TOTAL_QUOTES',

    totalEngagements = 'TOTAL_ENGAGEMENTS',

    aveFacet = 'AVE',
    handles = 'HANDLES',
    hashtags = 'HASHTAGS',

    // LLM
    viBooleanOverTimeFacet = 'VI_BOOLEANS_OVER_TIME',
    dynamicOvertimeFacet = 'OVER_TIME_DYNAMIC',
    viDynamicBooleanOverTimeFacet = 'VI_DYNAMIC_BOOLEANS_OVER_TIME',

    viBrandMentionTrend = 'VI_BRAND_MENTIONED_TREND', // presence rate
    viRiskFlag = 'VI_RISK_FLAG',
    ownDomainCited = 'VI_OWN_DOMAIN_CITED',

    viBrandScoreOverTime = 'VI_BRAND_SCORE_OVER_TIME',
    visibilityScoreOverTime = 'VI_ORGANIC_INCLUSION_OVER_TIME',
    avgRankWhenListedOverTime = 'VI_MENTION_RANK_OVER_TIME',
    sentimentScoreOverTime = 'VI_SENTIMENT_SCORE_OVER_TIME',
    accuracyScoreOverTime = 'VI_FACTUAL_ACCURACY_OVER_TIME',
    avgCitationPerScanOverTime = 'VI_CITATION_COUNT_OVER_TIME',
    ownDomainCitedOverTime = 'VI_OWN_DOMAIN_CITED_OVER_TIME',
    viBrandScoreCount = 'VI_BRAND_SCORE_COUNT',
    visibilityScoreCount = 'VI_ORGANIC_INCLUSION_COUNT',
    avgRankWhenListedCount = 'VI_MENTION_RANK_COUNT',
    sentimentScoreCount = 'VI_SENTIMENT_SCORE_COUNT',
    accuracyScoreCount = 'VI_FACTUAL_ACCURACY_COUNT',
    avgCitationPerScanCount = 'VI_CITATION_COUNT',

    viCompetitiveStrength = 'VI_COMPETITVE_STRENGTH'
}
